module.exports = __webpack_public_path__ + "img/bring-solutions.2c250938.svg";